<template>
    <BreadCrumb PageTitle="Ajout d'une sortie" />
    <AddSortie />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddSortie from "@/components/Sortie/AddSortie.vue";

    export default defineComponent({
        name: "AddSortiePage",
        components: {
            BreadCrumb,
            AddSortie,
        },
    });
</script>